import { gql } from "@apollo/client";

export const UPDATE_FRECUENCIA_DISTRIBUIDOR = gql`
    mutation updateFrecuenciaDistribuidor(
        $idFrecuenciaDistribuidor: Int!,
        $idProveedorDistribuidor: Int!,
        $kilometroDestino: Int!,
        $costoEntregaInmediata: Decimal!,
        $idDeposito: Int!,
        $activo: Boolean!,
        $idFrecuenciaModoDespacho: Int!,
        $listaFrecuenciaDistribuidorDetalles: [EditFrecuenciaDistribuidorDetalleInput!]!,
        $listaFrecuenciaDistribuidorCPs: [EditFrecuenciaDistribuidorCPInput!]!
    ){
        updateFrecuenciaDistribuidor(
            input: {
                idFrecuenciaDistribuidor: $idFrecuenciaDistribuidor,
                idProveedorDistribuidor: $idProveedorDistribuidor,
                kilometroDestino: $kilometroDestino,
                costoEntregaInmediata: $costoEntregaInmediata,
                idDeposito: $idDeposito,
                activo: $activo,
                idFrecuenciaModoDespacho: $idFrecuenciaModoDespacho,
                listaFrecuenciaDistribuidorDetalles: $listaFrecuenciaDistribuidorDetalles,
                listaFrecuenciaDistribuidorCPs: $listaFrecuenciaDistribuidorCPs
            }
        ) {
            idFrecuenciaDistribuidor
          }
    }
`;